import connect from 'react-redux/es/connect/connect';

import Licensing from '../components/Licensing';

const mapStateToProps = (state, { licensing, ...restOwnProps }) => {
    return {
        ...restOwnProps,
        options: licensing,
    };
};

const mapDispatchToProps = dispatch => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Licensing);

